export default __webpack_public_path__ + "assets/images/f4bd52e770f319a532bd01ab399f55a6.png";